import React, { FunctionComponent, useEffect, useState } from 'react';
import FileDownload from 'js-file-download';
import { useParams } from 'react-router-dom';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Stack,
  Typography,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import { IAlertProps } from '../../interface/IAlertProps';
import { GetCridDtoFromString, getDefaultAlertProps } from '../../utils/utils';
import { IApiResult } from '../../interface/IApiResult';
import {
  API_STATUS_PROBLEM,
  DOWNLOAD_FILE_NUM,
} from '../../constant/constants';
import { AlertSeverityEnum } from '../../enum/AlertSeverityEnum';
import { MyAlert } from '../UI/MyAlert';
import { ContentDto } from '../../dto/ContentDto';
import { apiGetCrib } from '../../service/apiGetCrib';
import { CribDto } from '../../dto/CribDto';
import { DialogCribItem } from './DialogCribItem';
import { BackDropDiv } from '../backdrop/BackDropDiv';

interface Props {
  open: boolean;
  isEdit?: boolean;
  onClose: () => void;
  dto?: ContentDto;
}

export const DialogCrib: FunctionComponent<Props> = ({
  open,
  dto,
  isEdit,
  onClose,
}) => {
  const [alertProps, setAlertProps] = useState<IAlertProps>(
    getDefaultAlertProps()
  );
  const [cribDtos, setCribDtos] = useState<CribDto[]>([]);
  const [backDrop, setBackDrop] = useState(false);
  const handleClose = () => {
    setCribDtos([]);
    onClose();
  };
  const { section } = useParams();

  const getCrib = async (route: string, key: string, download?: number) => {
    setBackDrop(true);
    const apiResult: IApiResult = await apiGetCrib(route, key, download);
    if (apiResult.isSuccess) {
      if (download === undefined) {
        if (apiResult.data.crib !== undefined) {
          setCribDtos(
            GetCridDtoFromString(apiResult.data.id, apiResult.data.crib)
          );
        }
      } else {
        FileDownload(
          apiResult.data,
          `${route}_подсказки_${dto?.key}_${dto?.title}.txt` ?? ''
        );
      }
    } else {
      setAlertProps({
        message: API_STATUS_PROBLEM,
        severity: AlertSeverityEnum.error,
      });
    }
    setBackDrop(false);
  };

  let numTest = 0;

  useEffect(() => {
    if (open) {
      getCrib(section ?? '', dto?.key ?? '');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        fullWidth
        maxWidth="xl"
        style={{ userSelect: 'none' }}
        PaperProps={{
          sx: { backgroundColor: '#e7ebee', width: '100%', height: '100%' },
        }}
      >
        <BackDropDiv open={backDrop} />
        <MyAlert
          message={alertProps.message}
          severity={alertProps.severity}
          onClose={() => setAlertProps({ ...alertProps, message: '' })}
        />
        <DialogTitle>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Typography
              style={{
                fontFamily: 'sans-serif',
                fontStyle: 'normal',
                fontWeight: 500,
                fontSize: '24px',
                color: '#000000',
                letterSpacing: 1,
              }}
              component="text"
            >
              {`Подсказки - ${dto?.key} ${dto?.title}`}
            </Typography>
            <Stack direction="row" spacing={1}>
              {!isEdit && (
                <Stack direction="row" spacing={1}>
                  <IconButton
                    title="Скачать"
                    size="small"
                    onClick={() =>
                      getCrib(section ?? '', dto?.key ?? '', DOWNLOAD_FILE_NUM)
                    }
                  >
                    <DownloadIcon fontSize="large" sx={{ color: '#9c27b0' }} />
                  </IconButton>
                </Stack>
              )}
              <IconButton title="Закрыть" size="small" onClick={handleClose}>
                <CloseIcon fontSize="large" sx={{ color: '#000000' }} />
              </IconButton>
            </Stack>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2}>
            {cribDtos.map((item) => {
              numTest += 1;
              return (
                <div>
                  <DialogCribItem
                    isEdit={isEdit === true}
                    num={numTest}
                    key={numTest}
                    keyTitle={dto?.key ?? ''}
                    titleName={dto?.title ?? ''}
                    dto={item}
                  />
                  <Divider />
                </div>
              );
            })}
          </Stack>
        </DialogContent>
      </Dialog>
    </div>
  );
};

DialogCrib.defaultProps = {
  isEdit: false,
  dto: undefined,
};
